import { createComponent } from "../utils";

export default createComponent({
  name: "Rotate",
  description: "Rotate",
  group: "Transform",
  icon: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 474 474"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M408.04 176.21C383.2 106.616 318.716 58.97 244.9 55.66V8.10495C244.9 3.74555 241.365 0.210449 237.005 0.210449C232.646 0.210449 229.115 3.74565 229.115 8.10495V55.66C155.291 58.9686 90.8147 106.617 65.9747 176.21C23.5687 192.011 0.220703 213.507 0.220703 236.999C0.220703 260.495 23.5757 281.999 65.9747 297.796C90.8187 367.39 155.299 415.036 229.115 418.336V465.895C229.115 470.254 232.646 473.789 237.005 473.789C241.365 473.789 244.9 470.254 244.9 465.895V418.336C318.72 415.031 383.2 367.383 408.04 297.786C450.442 281.989 473.794 260.489 473.794 236.997C473.794 213.505 450.442 192.009 408.04 176.208V176.21ZM15.9998 236.999C15.9998 222.581 31.9688 207.796 60.3158 195.464C53.847 222.776 53.847 251.222 60.3158 278.534C31.9678 266.206 15.9998 251.421 15.9998 236.999V236.999ZM237 402.749C171.578 402.659 112.32 364.124 85.6998 304.366C116.415 313.147 147.93 318.835 179.778 321.343L164.051 337.07C160.969 340.152 160.969 345.148 164.051 348.23C167.133 351.312 172.133 351.312 175.215 348.23L203.117 320.324C203.293 320.094 203.453 319.851 203.597 319.597C204.437 318.746 204.968 317.636 205.097 316.449C205.238 316.047 205.343 315.633 205.414 315.215C205.418 315.136 205.379 315.066 205.382 314.988C205.367 314.402 205.285 313.824 205.14 313.258C205.121 312.367 204.796 311.508 204.222 310.824C203.953 310.3 203.625 309.804 203.242 309.355C203.191 309.297 203.171 309.218 203.117 309.164L175.215 281.258C172.133 278.176 167.133 278.176 164.051 281.258C160.969 284.34 160.969 289.336 164.051 292.418L176.828 305.195C143.406 302.445 110.418 295.831 78.5188 285.484C57.6828 217.48 82.554 143.764 140.328 102.284C198.101 60.8037 275.898 60.8037 333.668 102.284C391.441 143.761 416.313 217.474 395.48 285.484C356.765 297.847 316.589 305.039 275.99 306.871C271.736 307.129 268.451 310.718 268.576 314.98C268.701 319.242 272.189 322.632 276.451 322.64C276.615 322.64 276.767 322.636 276.931 322.625C314.622 320.757 351.982 314.632 388.301 304.367C361.68 364.129 302.418 402.664 237.001 402.754L237 402.749ZM413.69 278.529C420.155 251.22 420.155 222.775 413.69 195.463C442.034 207.795 458.002 222.58 458.002 236.998C458.002 251.416 442.041 266.197 413.69 278.529V278.529Z"
        fill="currentColor"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "geometry",
      name: "Geometry",
      type: "Geometry",
    },
    {
      id: "rotation",
      name: "Rotation",
      type: "Number",
    },
    {
      id: "axis",
      name: "Axis",
      type: "Vector",
    },
    {
      id: "point",
      name: "Point",
      type: "Point",
    },
  ],
  outputs: [
    {
      id: "moved",
      name: "Geometry",
      type: "Geometry",
      compute: ({
        geometry,
        rotation = 0,
        axis = [0, 1, 0],
        point = [0, 0, 0],
      }) => {
        if (geometry?.rotate) {
          const newGeometry = geometry.duplicate();
          const radian = rotation * (Math.PI / 180);
          newGeometry.rotate(radian, axis, point);
          return newGeometry;
        }
      },
    },
  ],
});
